import { Box, SxProps, Theme, Tooltip, Typography } from "@mui/material";
import { ImFilePdf } from "react-icons/im";
import CardBox from "../../../main/components/CardBox";
import React from "react";

type CardDownloadProps = {
  label: React.ReactNode;
  tooltipText?: string | null;
  onClick: () => void;
  sx?: SxProps<Theme>;
};

export default function CardDownload(props: CardDownloadProps) {
  return (
    <CardBox
      onClick={props.onClick}
      sx={{ height: "100%", cursor: "pointer", ...props.sx }}
    >
      <Tooltip placement="top" title={props.tooltipText ?? ""}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            columnGap: "10px",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            {props.label}
          </Typography>
          <ImFilePdf color="#f44336" size={"5.5rem"} />
        </Box>
      </Tooltip>
    </CardBox>
  );
}
